import React from 'react';

import AemComponent from '@/components/Aem/AemComponent/AemComponent';
import EditableText from '@/components/Aem/EditableText/EditableText';
import {AppButton} from '@/components/Button';
import {ConfirmationIcon} from '@/components/Icons';
import {CONSUMER_FEEDBACK_POPUP_GO_BACK_BUTTON_ARIA_LABEL} from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import {getAriaLabel} from '@/services/accessibilityService';

const ThanksPopupContent = ({headerId, onBackButtonClick}) => {
    return (
        <div className='flex w-full flex-col items-center justify-between'>
            <ConfirmationIcon className='ml:mt-5' />
            <h1 id={headerId} className='mb-2 mt-1 w-full break-words text-28'>
                <AemComponent component={EditableText} pageName={routePaths.MODALS} itemName='thankstitle' />
            </h1>
            <p className='w-full break-words text-14 ml:text-16'>
                <AemComponent component={EditableText} pageName={routePaths.MODALS} itemName='thankssubtitle' />
            </p>
            <AppButton
                className='mt-8 min-h-12 max-w-[312px] break-words ml:w-full ml:max-w-none'
                aria-label={getAriaLabel(CONSUMER_FEEDBACK_POPUP_GO_BACK_BUTTON_ARIA_LABEL)}
                onClick={onBackButtonClick}
                primary
                light
            >
                <AemComponent component={EditableText} pageName={routePaths.MODALS} itemName='thanksbuttonlabel' />
            </AppButton>
        </div>
    );
};

export default ThanksPopupContent;
